<script>
import { mapGetters } from 'vuex'
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  name: 'app-smart-catalog-item_content',
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
    name: String,
    price: String,
    numberFormat: Object
  },
  computed: {
    currency() {
      return `${Number(this.price).toLocaleString()} ${getSymbolFromCurrency(this.numberFormat.currency)}`
    },
    ...mapGetters({
      getCatalogConstantTranslationByKey: 'account/getCatalogConstantTranslationByKey',
      getTranslatedParam: 'account/getTranslatedParam',
    })
  },
  methods: {
    value(values) {
      return values.length 
        ? values.reduce((acc, { value }, idx) => {
            if (idx > 0) {
              acc += ', '
            }
            acc += value
            return acc
          }, '')
        : this.getCatalogConstantTranslationByKey('empty-field')
    }
  }
}
</script>

<template>
  <ol class="py-5 px-4">
    <li class="text-leadNameColor text-base overflow-hidden">{{ name }}</li>
    <li class="text-black font-bold">{{ currency }}</li>
    <li
        class="text-sm"
        v-for="option of options"
        :key="option.fieldId"
    >
      <span class="text-gray-500">{{ getTranslatedParam(option.name) }}: </span>
      <span class="">{{ getTranslatedParam(value(option.values)) }}</span>
    </li>
  </ol>
</template>

<style scoped>
</style>
